// Componente OfflineBanner (Sprint 9).
//
// Detecta `navigator.onLine` y muestra un banner sutil cuando
// se pierde la conexión. El service worker sigue funcionando en
// background, pero las llamadas a `/api/*` van a fallar —
// el usuario debe saberlo.

import { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';

export function OfflineBanner(): React.ReactElement | null {
  const [online, setOnline] = useState(typeof navigator !== 'undefined' ? navigator.onLine : true);

  useEffect(() => {
    const onOnline = (): void => setOnline(true);
    const onOffline = (): void => setOnline(false);
    window.addEventListener('online', onOnline);
    window.addEventListener('offline', onOffline);
    return () => {
      window.removeEventListener('online', onOnline);
      window.removeEventListener('offline', onOffline);
    };
  }, []);

  return (
    <AnimatePresence>
      {!online && (
        <motion.div
          initial={{ y: -40, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          exit={{ y: -40, opacity: 0 }}
          transition={{ duration: 0.2 }}
          className="fixed left-0 right-0 top-0 z-40 bg-blood px-4 py-2 text-center text-sm font-semibold text-text shadow-card"
          role="status"
          aria-live="polite"
          data-testid="offline-banner"
        >
          ⚠ Sin conexión. Tus saves locales siguen funcionando.
        </motion.div>
      )}
    </AnimatePresence>
  );
}
